// source: livongo/protobuf/grpc/external/enrollment/common/validation_errors.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var livongo_protobuf_grpc_external_enrollment_common_section_ids_pb = require('../../../../../../livongo/protobuf/grpc/external/enrollment/common/section_ids_pb.js');
goog.object.extend(proto, livongo_protobuf_grpc_external_enrollment_common_section_ids_pb);
var livongo_protobuf_grpc_external_enrollment_common_element_pb = require('../../../../../../livongo/protobuf/grpc/external/enrollment/common/element_pb.js');
goog.object.extend(proto, livongo_protobuf_grpc_external_enrollment_common_element_pb);
var livongo_protobuf_grpc_external_enrollment_common_question_ids_pb = require('../../../../../../livongo/protobuf/grpc/external/enrollment/common/question_ids_pb.js');
goog.object.extend(proto, livongo_protobuf_grpc_external_enrollment_common_question_ids_pb);
var livongo_protobuf_grpc_external_enrollment_common_typed_field_names_pb = require('../../../../../../livongo/protobuf/grpc/external/enrollment/common/typed_field_names_pb.js');
goog.object.extend(proto, livongo_protobuf_grpc_external_enrollment_common_typed_field_names_pb);
var livongo_protobuf_grpc_external_enrollment_common_password_rule_pb = require('../../../../../../livongo/protobuf/grpc/external/enrollment/common/password_rule_pb.js');
goog.object.extend(proto, livongo_protobuf_grpc_external_enrollment_common_password_rule_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CodeCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.ErrorCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.LimitCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.LimitCase', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.oneofGroups_);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.displayName = 'proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CodeCase = {
  CODE_NOT_SET: 0,
  MISSING: 1,
  WRONG_TYPE: 2,
  UNDERFLOW: 3,
  OVERFLOW: 4,
  ILLEGAL_ENUM_VALUE: 5,
  ILLEGAL_SCALAR_VALUE: 6,
  PASSWORD_MISSING_CHAR_SETS: 7,
  DATE_DOES_NOT_EXIST: 8,
  INVALID_PROGRAMS_SET: 9,
  EMAIL_IN_USE: 10,
  ANSWERED_TWICE: 11,
  FLOW_ERROR: 12,
  DUPLICATES: 13,
  UNDEFINED: 14,
  UNKNOWN_QUESTION_ID: 15,
  UNKNOWN_ENUM_VALUE: 16,
  UNKNOWN_NODE: 17,
  UNKNOWN_BRANCH_POINT: 18,
  UNKNOWN_REFERENCE: 19,
  INVALID_REG_CODE: 20,
  INVALID_PASSWORD: 21,
  INVALID_PHONE_NUMBER: 22,
  MALFORMED_URL: 23,
  EMPTY_RESPONSE: 24,
  UNSUPPORTED_PROGRAMS: 25,
  USER_INELIGIBLE: 26,
  ALREADY_ENROLLED: 27,
  INCORRECT_BIRTH_DATE: 28,
  COUNTRY_NOT_SUPPORTED: 29,
  INVALID_ZIP_CODE: 30,
  CONFIRM_DOB_ATTEMPTS_EXHAUSTED: 31
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CodeCase}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getCodeCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CodeCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.toObject = function(includeInstance, msg) {
  var f, obj = {
    missing: (f = msg.getMissing()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.toObject(includeInstance, f),
    wrongType: (f = msg.getWrongType()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.toObject(includeInstance, f),
    underflow: (f = msg.getUnderflow()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.toObject(includeInstance, f),
    overflow: (f = msg.getOverflow()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.toObject(includeInstance, f),
    illegalEnumValue: (f = msg.getIllegalEnumValue()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.toObject(includeInstance, f),
    illegalScalarValue: (f = msg.getIllegalScalarValue()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.toObject(includeInstance, f),
    passwordMissingCharSets: (f = msg.getPasswordMissingCharSets()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.toObject(includeInstance, f),
    dateDoesNotExist: (f = msg.getDateDoesNotExist()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.toObject(includeInstance, f),
    invalidProgramsSet: (f = msg.getInvalidProgramsSet()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.toObject(includeInstance, f),
    emailInUse: (f = msg.getEmailInUse()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.toObject(includeInstance, f),
    answeredTwice: (f = msg.getAnsweredTwice()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.toObject(includeInstance, f),
    flowError: (f = msg.getFlowError()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.toObject(includeInstance, f),
    duplicates: (f = msg.getDuplicates()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.toObject(includeInstance, f),
    undefined: (f = msg.getUndefined()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.toObject(includeInstance, f),
    unknownQuestionId: (f = msg.getUnknownQuestionId()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.toObject(includeInstance, f),
    unknownEnumValue: (f = msg.getUnknownEnumValue()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.toObject(includeInstance, f),
    unknownNode: (f = msg.getUnknownNode()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.toObject(includeInstance, f),
    unknownBranchPoint: (f = msg.getUnknownBranchPoint()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.toObject(includeInstance, f),
    unknownReference: (f = msg.getUnknownReference()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.toObject(includeInstance, f),
    invalidRegCode: (f = msg.getInvalidRegCode()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.toObject(includeInstance, f),
    invalidPassword: (f = msg.getInvalidPassword()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.toObject(includeInstance, f),
    invalidPhoneNumber: (f = msg.getInvalidPhoneNumber()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.toObject(includeInstance, f),
    malformedUrl: (f = msg.getMalformedUrl()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.toObject(includeInstance, f),
    emptyResponse: (f = msg.getEmptyResponse()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.toObject(includeInstance, f),
    unsupportedPrograms: (f = msg.getUnsupportedPrograms()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.toObject(includeInstance, f),
    userIneligible: (f = msg.getUserIneligible()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.toObject(includeInstance, f),
    alreadyEnrolled: (f = msg.getAlreadyEnrolled()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.toObject(includeInstance, f),
    incorrectBirthDate: (f = msg.getIncorrectBirthDate()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.toObject(includeInstance, f),
    countryNotSupported: (f = msg.getCountryNotSupported()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.toObject(includeInstance, f),
    invalidZipCode: (f = msg.getInvalidZipCode()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.toObject(includeInstance, f),
    confirmDobAttemptsExhausted: (f = msg.getConfirmDobAttemptsExhausted()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.deserializeBinaryFromReader);
      msg.setMissing(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.deserializeBinaryFromReader);
      msg.setWrongType(value);
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.deserializeBinaryFromReader);
      msg.setUnderflow(value);
      break;
    case 4:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.deserializeBinaryFromReader);
      msg.setOverflow(value);
      break;
    case 5:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.deserializeBinaryFromReader);
      msg.setIllegalEnumValue(value);
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.deserializeBinaryFromReader);
      msg.setIllegalScalarValue(value);
      break;
    case 7:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.deserializeBinaryFromReader);
      msg.setPasswordMissingCharSets(value);
      break;
    case 8:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.deserializeBinaryFromReader);
      msg.setDateDoesNotExist(value);
      break;
    case 9:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.deserializeBinaryFromReader);
      msg.setInvalidProgramsSet(value);
      break;
    case 10:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.deserializeBinaryFromReader);
      msg.setEmailInUse(value);
      break;
    case 11:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.deserializeBinaryFromReader);
      msg.setAnsweredTwice(value);
      break;
    case 12:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.deserializeBinaryFromReader);
      msg.setFlowError(value);
      break;
    case 13:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.deserializeBinaryFromReader);
      msg.setDuplicates(value);
      break;
    case 14:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.deserializeBinaryFromReader);
      msg.setUndefined(value);
      break;
    case 15:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.deserializeBinaryFromReader);
      msg.setUnknownQuestionId(value);
      break;
    case 16:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.deserializeBinaryFromReader);
      msg.setUnknownEnumValue(value);
      break;
    case 17:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.deserializeBinaryFromReader);
      msg.setUnknownNode(value);
      break;
    case 18:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.deserializeBinaryFromReader);
      msg.setUnknownBranchPoint(value);
      break;
    case 19:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.deserializeBinaryFromReader);
      msg.setUnknownReference(value);
      break;
    case 20:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.deserializeBinaryFromReader);
      msg.setInvalidRegCode(value);
      break;
    case 21:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.deserializeBinaryFromReader);
      msg.setInvalidPassword(value);
      break;
    case 22:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.deserializeBinaryFromReader);
      msg.setInvalidPhoneNumber(value);
      break;
    case 23:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.deserializeBinaryFromReader);
      msg.setMalformedUrl(value);
      break;
    case 24:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.deserializeBinaryFromReader);
      msg.setEmptyResponse(value);
      break;
    case 25:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.deserializeBinaryFromReader);
      msg.setUnsupportedPrograms(value);
      break;
    case 26:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.deserializeBinaryFromReader);
      msg.setUserIneligible(value);
      break;
    case 27:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.deserializeBinaryFromReader);
      msg.setAlreadyEnrolled(value);
      break;
    case 28:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.deserializeBinaryFromReader);
      msg.setIncorrectBirthDate(value);
      break;
    case 29:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.deserializeBinaryFromReader);
      msg.setCountryNotSupported(value);
      break;
    case 30:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.deserializeBinaryFromReader);
      msg.setInvalidZipCode(value);
      break;
    case 31:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.deserializeBinaryFromReader);
      msg.setConfirmDobAttemptsExhausted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMissing();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.serializeBinaryToWriter
    );
  }
  f = message.getWrongType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.serializeBinaryToWriter
    );
  }
  f = message.getUnderflow();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.serializeBinaryToWriter
    );
  }
  f = message.getOverflow();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.serializeBinaryToWriter
    );
  }
  f = message.getIllegalEnumValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.serializeBinaryToWriter
    );
  }
  f = message.getIllegalScalarValue();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.serializeBinaryToWriter
    );
  }
  f = message.getPasswordMissingCharSets();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.serializeBinaryToWriter
    );
  }
  f = message.getDateDoesNotExist();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.serializeBinaryToWriter
    );
  }
  f = message.getInvalidProgramsSet();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.serializeBinaryToWriter
    );
  }
  f = message.getEmailInUse();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.serializeBinaryToWriter
    );
  }
  f = message.getAnsweredTwice();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.serializeBinaryToWriter
    );
  }
  f = message.getFlowError();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.serializeBinaryToWriter
    );
  }
  f = message.getDuplicates();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.serializeBinaryToWriter
    );
  }
  f = message.getUndefined();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.serializeBinaryToWriter
    );
  }
  f = message.getUnknownQuestionId();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.serializeBinaryToWriter
    );
  }
  f = message.getUnknownEnumValue();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.serializeBinaryToWriter
    );
  }
  f = message.getUnknownNode();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.serializeBinaryToWriter
    );
  }
  f = message.getUnknownBranchPoint();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.serializeBinaryToWriter
    );
  }
  f = message.getUnknownReference();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.serializeBinaryToWriter
    );
  }
  f = message.getInvalidRegCode();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.serializeBinaryToWriter
    );
  }
  f = message.getInvalidPassword();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.serializeBinaryToWriter
    );
  }
  f = message.getInvalidPhoneNumber();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.serializeBinaryToWriter
    );
  }
  f = message.getMalformedUrl();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.serializeBinaryToWriter
    );
  }
  f = message.getEmptyResponse();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.serializeBinaryToWriter
    );
  }
  f = message.getUnsupportedPrograms();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.serializeBinaryToWriter
    );
  }
  f = message.getUserIneligible();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.serializeBinaryToWriter
    );
  }
  f = message.getAlreadyEnrolled();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.serializeBinaryToWriter
    );
  }
  f = message.getIncorrectBirthDate();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.serializeBinaryToWriter
    );
  }
  f = message.getCountryNotSupported();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.serializeBinaryToWriter
    );
  }
  f = message.getInvalidZipCode();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.serializeBinaryToWriter
    );
  }
  f = message.getConfirmDobAttemptsExhausted();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.toObject = function(includeInstance, msg) {
  var f, obj = {
    received: jspb.Message.getFieldWithDefault(msg, 1, 0),
    expected: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} */ (reader.readEnum());
      msg.setReceived(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} */ (reader.readEnum());
      msg.setExpected(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceived();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExpected();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional TypeName received = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.getReceived = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.setReceived = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TypeName expected = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.getExpected = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.TypeName} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType.prototype.setExpected = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.LimitCase = {
  LIMIT_NOT_SET: 0,
  INT_VALUE: 1,
  FLOAT_VALUE: 2
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.LimitCase}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.getLimitCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.LimitCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.toObject = function(includeInstance, msg) {
  var f, obj = {
    intValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    floatValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloatValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional int32 int_value = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.getIntValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.setIntValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.clearIntValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.hasIntValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float float_value = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.getFloatValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.setFloatValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.clearFloatValue = function() {
  return jspb.Message.setOneofField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow.prototype.hasFloatValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.LimitCase = {
  LIMIT_NOT_SET: 0,
  INT_VALUE: 1,
  FLOAT_VALUE: 2
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.LimitCase}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.getLimitCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.LimitCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.toObject = function(includeInstance, msg) {
  var f, obj = {
    intValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    floatValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloatValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional int32 int_value = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.getIntValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.setIntValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.clearIntValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.hasIntValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float float_value = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.getFloatValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.setFloatValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.clearFloatValue = function() {
  return jspb.Message.setOneofField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow.prototype.hasFloatValue = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    rejectedValuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRejectedValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRejectedValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string rejected_values = 1;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.getRejectedValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.setRejectedValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.addRejectedValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue.prototype.clearRejectedValuesList = function() {
  return this.setRejectedValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.toObject = function(includeInstance, msg) {
  var f, obj = {
    missingCharsOfTheseTypesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMissingCharsOfTheseTypes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMissingCharsOfTheseTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet = {
  UNKNOWN: 0,
  LOWER_LETTER: 1,
  UPPER_LETTER: 2,
  NUMBER: 3,
  SPECIAL: 4
};

/**
 * repeated CharSet missing_chars_of_these_types = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.getMissingCharsOfTheseTypesList = function() {
  return /** @type {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.setMissingCharsOfTheseTypesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.CharSet} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.addMissingCharsOfTheseTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets.prototype.clearMissingCharsOfTheseTypesList = function() {
  return this.setMissingCharsOfTheseTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.toObject = function(includeInstance, msg) {
  var f, obj = {
    violatedRulesList: jspb.Message.toObjectList(msg.getViolatedRulesList(),
    livongo_protobuf_grpc_external_enrollment_common_password_rule_pb.PasswordRule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new livongo_protobuf_grpc_external_enrollment_common_password_rule_pb.PasswordRule;
      reader.readMessage(value,livongo_protobuf_grpc_external_enrollment_common_password_rule_pb.PasswordRule.deserializeBinaryFromReader);
      msg.addViolatedRules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViolatedRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      livongo_protobuf_grpc_external_enrollment_common_password_rule_pb.PasswordRule.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PasswordRule violated_rules = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.getViolatedRulesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, livongo_protobuf_grpc_external_enrollment_common_password_rule_pb.PasswordRule, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.setViolatedRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.addViolatedRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.enrollment.common.PasswordRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword.prototype.clearViolatedRulesList = function() {
  return this.setViolatedRulesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    conflictingProgramsList: jspb.Message.toObjectList(msg.getConflictingProgramsList(),
    proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.toObject, includeInstance),
    possibleAnchorProgramsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.deserializeBinaryFromReader);
      msg.addConflictingPrograms(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addPossibleAnchorPrograms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConflictingProgramsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.serializeBinaryToWriter
    );
  }
  f = message.getPossibleAnchorProgramsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectedProgram: jspb.Message.getFieldWithDefault(msg, 1, ""),
    incompatibleProgramsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelectedProgram(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncompatiblePrograms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectedProgram();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncompatibleProgramsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string selected_program = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.getSelectedProgram = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.setSelectedProgram = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string incompatible_programs = 2;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.getIncompatibleProgramsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.setIncompatibleProgramsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.addIncompatiblePrograms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms.prototype.clearIncompatibleProgramsList = function() {
  return this.setIncompatibleProgramsList([]);
};


/**
 * repeated ConflictingPrograms conflicting_programs = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.getConflictingProgramsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.setConflictingProgramsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.addConflictingPrograms = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.ConflictingPrograms, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.clearConflictingProgramsList = function() {
  return this.setConflictingProgramsList([]);
};


/**
 * repeated string possible_anchor_programs = 2;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.getPossibleAnchorProgramsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.setPossibleAnchorProgramsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.addPossibleAnchorPrograms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet.prototype.clearPossibleAnchorProgramsList = function() {
  return this.setPossibleAnchorProgramsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.toObject = function(includeInstance, msg) {
  var f, obj = {
    duplicatedAnswerForQuestionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} */ (reader.readEnum());
      msg.setDuplicatedAnswerForQuestionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDuplicatedAnswerForQuestionId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional QuestionId.Values duplicated_answer_for_question_id = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.prototype.getDuplicatedAnswerForQuestionId = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.QuestionId.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice.prototype.setDuplicatedAnswerForQuestionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.toObject = function(includeInstance, msg) {
  var f, obj = {
    locationOfOriginalList: jspb.Message.toObjectList(msg.getLocationOfOriginalList(),
    livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.toObject, includeInstance),
    locationOfDuplicateList: jspb.Message.toObjectList(msg.getLocationOfDuplicateList(),
    livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new livongo_protobuf_grpc_external_enrollment_common_element_pb.Element;
      reader.readMessage(value,livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.deserializeBinaryFromReader);
      msg.addLocationOfOriginal(value);
      break;
    case 2:
      var value = new livongo_protobuf_grpc_external_enrollment_common_element_pb.Element;
      reader.readMessage(value,livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.deserializeBinaryFromReader);
      msg.addLocationOfDuplicate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationOfOriginalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.serializeBinaryToWriter
    );
  }
  f = message.getLocationOfDuplicateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      livongo_protobuf_grpc_external_enrollment_common_element_pb.Element.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Element location_of_original = 1;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.getLocationOfOriginalList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>} */ (
    jspb.Message.getRepeatedWrapperField(this, livongo_protobuf_grpc_external_enrollment_common_element_pb.Element, 1));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.setLocationOfOriginalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.addLocationOfOriginal = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.livongo.protobuf.grpc.external.enrollment.common.Element, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.clearLocationOfOriginalList = function() {
  return this.setLocationOfOriginalList([]);
};


/**
 * repeated Element location_of_duplicate = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.getLocationOfDuplicateList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>} */ (
    jspb.Message.getRepeatedWrapperField(this, livongo_protobuf_grpc_external_enrollment_common_element_pb.Element, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.setLocationOfDuplicateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.Element}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.addLocationOfDuplicate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.enrollment.common.Element, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates.prototype.clearLocationOfDuplicateList = function() {
  return this.setLocationOfDuplicateList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    regCodeError: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError} */ (reader.readEnum());
      msg.setRegCodeError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegCodeError();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError = {
  INVALID: 0,
  NOT_FOUND: 1,
  INACTIVE: 2
};

/**
 * optional RegCodeError reg_code_error = 1;
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.prototype.getRegCodeError = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.RegCodeError} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode.prototype.setRegCodeError = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.ErrorCase = {
  ERROR_NOT_SET: 0,
  INVALID_NUMBER: 1,
  INTERNATIONAL_NUMBER_NOT_ALLOWED: 2
};

/**
 * @return {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.ErrorCase}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.getErrorCase = function() {
  return /** @type {proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.ErrorCase} */(jspb.Message.computeOneofCase(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.toObject = function(includeInstance, msg) {
  var f, obj = {
    invalidNumber: (f = msg.getInvalidNumber()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    internationalNumberNotAllowed: (f = msg.getInternationalNumberNotAllowed()) && proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setInvalidNumber(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.deserializeBinaryFromReader);
      msg.setInternationalNumberNotAllowed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvalidNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getInternationalNumberNotAllowed();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client_name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Empty invalid_number = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.getInvalidNumber = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.setInvalidNumber = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.clearInvalidNumber = function() {
  return this.setInvalidNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.hasInvalidNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InternationalNumberNotAllowed international_number_not_allowed = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.getInternationalNumberNotAllowed = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.InternationalNumberNotAllowed|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.setInternationalNumberNotAllowed = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.clearInternationalNumberNotAllowed = function() {
  return this.setInternationalNumberNotAllowed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber.prototype.hasInternationalNumberNotAllowed = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.toObject = function(includeInstance, msg) {
  var f, obj = {
    invalidUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvalidUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvalidUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invalid_url = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.prototype.getInvalidUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl.prototype.setInvalidUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionIdValue: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionIdValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionIdValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 question_id_value = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.getQuestionIdValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.setQuestionIdValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    enumName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnumName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnumName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string enum_name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.getEnumName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.setEnumName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 value = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    nodeName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodeName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodeName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string node_name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.prototype.getNodeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode.prototype.setNodeName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    branchPointName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranchPointName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBranchPointName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string branch_point_name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.prototype.getBranchPointName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint.prototype.setBranchPointName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.toObject = function(includeInstance, msg) {
  var f, obj = {
    referenceType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    referenceValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferenceType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReferenceValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string reference_type = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.getReferenceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.setReferenceType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reference_value = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.getReferenceValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference.prototype.setReferenceValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldNamesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFieldNames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string field_names = 1;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.getFieldNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.setFieldNamesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.addFieldNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse.prototype.clearFieldNamesList = function() {
  return this.setFieldNamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    unsupportedProgramsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addUnsupportedPrograms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnsupportedProgramsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string client_name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string unsupported_programs = 2;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.getUnsupportedProgramsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.setUnsupportedProgramsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.addUnsupportedPrograms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms.prototype.clearUnsupportedProgramsList = function() {
  return this.setUnsupportedProgramsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.toObject = function(includeInstance, msg) {
  var f, obj = {
    eligibilityType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEligibilityType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEligibilityType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string eligibility_type = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.getEligibilityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.setEligibilityType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.toObject = function(includeInstance, msg) {
  var f, obj = {
    alreadyEnrolledProgramsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAlreadyEnrolledPrograms(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlreadyEnrolledProgramsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string already_enrolled_programs = 1;
 * @return {!Array<string>}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.getAlreadyEnrolledProgramsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.setAlreadyEnrolledProgramsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.addAlreadyEnrolledPrograms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled.prototype.clearAlreadyEnrolledProgramsList = function() {
  return this.setAlreadyEnrolledProgramsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.toObject = function(includeInstance, msg) {
  var f, obj = {
    attemptsRemaining: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttemptsRemaining(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttemptsRemaining();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 attempts_remaining = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.prototype.getAttemptsRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate.prototype.setAttemptsRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.toObject = function(includeInstance, msg) {
  var f, obj = {
    countryCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string country_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_name = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.getClientName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported.prototype.setClientName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    reason: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string reason = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted;
  return proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Missing missing = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getMissing = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Missing|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setMissing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearMissing = function() {
  return this.setMissing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasMissing = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional WrongType wrong_type = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getWrongType = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.WrongType|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setWrongType = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearWrongType = function() {
  return this.setWrongType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasWrongType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Underflow underflow = 3;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnderflow = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Underflow|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnderflow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnderflow = function() {
  return this.setUnderflow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnderflow = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Overflow overflow = 4;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getOverflow = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow, 4));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Overflow|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setOverflow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearOverflow = function() {
  return this.setOverflow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasOverflow = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional IllegalEnumValue illegal_enum_value = 5;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getIllegalEnumValue = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue, 5));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalEnumValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setIllegalEnumValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearIllegalEnumValue = function() {
  return this.setIllegalEnumValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasIllegalEnumValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional IllegalScalarValue illegal_scalar_value = 6;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getIllegalScalarValue = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue, 6));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IllegalScalarValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setIllegalScalarValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearIllegalScalarValue = function() {
  return this.setIllegalScalarValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasIllegalScalarValue = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PasswordMissingCharSets password_missing_char_sets = 7;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getPasswordMissingCharSets = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets, 7));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.PasswordMissingCharSets|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setPasswordMissingCharSets = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearPasswordMissingCharSets = function() {
  return this.setPasswordMissingCharSets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasPasswordMissingCharSets = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional DateDoesNotExist date_does_not_exist = 8;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getDateDoesNotExist = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist, 8));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.DateDoesNotExist|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setDateDoesNotExist = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearDateDoesNotExist = function() {
  return this.setDateDoesNotExist(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasDateDoesNotExist = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional InvalidProgramsSet invalid_programs_set = 9;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getInvalidProgramsSet = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet, 9));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidProgramsSet|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setInvalidProgramsSet = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearInvalidProgramsSet = function() {
  return this.setInvalidProgramsSet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasInvalidProgramsSet = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional EmailInUse email_in_use = 10;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getEmailInUse = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse, 10));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmailInUse|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setEmailInUse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearEmailInUse = function() {
  return this.setEmailInUse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasEmailInUse = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional AnsweredTwice answered_twice = 11;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getAnsweredTwice = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice, 11));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AnsweredTwice|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setAnsweredTwice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearAnsweredTwice = function() {
  return this.setAnsweredTwice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasAnsweredTwice = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional FlowError flow_error = 12;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getFlowError = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError, 12));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.FlowError|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setFlowError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearFlowError = function() {
  return this.setFlowError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasFlowError = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Duplicates duplicates = 13;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getDuplicates = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates, 13));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Duplicates|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setDuplicates = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearDuplicates = function() {
  return this.setDuplicates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasDuplicates = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Undefined undefined = 14;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUndefined = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined, 14));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.Undefined|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUndefined = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUndefined = function() {
  return this.setUndefined(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUndefined = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional UnknownQuestionId unknown_question_id = 15;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnknownQuestionId = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId, 15));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownQuestionId|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnknownQuestionId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnknownQuestionId = function() {
  return this.setUnknownQuestionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnknownQuestionId = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional UnknownEnumValue unknown_enum_value = 16;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnknownEnumValue = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue, 16));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownEnumValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnknownEnumValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnknownEnumValue = function() {
  return this.setUnknownEnumValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnknownEnumValue = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional UnknownNode unknown_node = 17;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnknownNode = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode, 17));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownNode|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnknownNode = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnknownNode = function() {
  return this.setUnknownNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnknownNode = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional UnknownBranchPoint unknown_branch_point = 18;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnknownBranchPoint = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint, 18));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownBranchPoint|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnknownBranchPoint = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnknownBranchPoint = function() {
  return this.setUnknownBranchPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnknownBranchPoint = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional UnknownReference unknown_reference = 19;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnknownReference = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference, 19));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnknownReference|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnknownReference = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnknownReference = function() {
  return this.setUnknownReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnknownReference = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional InvalidRegCode invalid_reg_code = 20;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getInvalidRegCode = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode, 20));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidRegCode|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setInvalidRegCode = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearInvalidRegCode = function() {
  return this.setInvalidRegCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasInvalidRegCode = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional InvalidPassword invalid_password = 21;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getInvalidPassword = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword, 21));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPassword|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setInvalidPassword = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearInvalidPassword = function() {
  return this.setInvalidPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasInvalidPassword = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional InvalidPhoneNumber invalid_phone_number = 22;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getInvalidPhoneNumber = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber, 22));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidPhoneNumber|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setInvalidPhoneNumber = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearInvalidPhoneNumber = function() {
  return this.setInvalidPhoneNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasInvalidPhoneNumber = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional MalformedUrl malformed_url = 23;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getMalformedUrl = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl, 23));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.MalformedUrl|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setMalformedUrl = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearMalformedUrl = function() {
  return this.setMalformedUrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasMalformedUrl = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional EmptyResponse empty_response = 24;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getEmptyResponse = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse, 24));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.EmptyResponse|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setEmptyResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearEmptyResponse = function() {
  return this.setEmptyResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasEmptyResponse = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional UnsupportedPrograms unsupported_programs = 25;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUnsupportedPrograms = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms, 25));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UnsupportedPrograms|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUnsupportedPrograms = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUnsupportedPrograms = function() {
  return this.setUnsupportedPrograms(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUnsupportedPrograms = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional UserIneligible user_ineligible = 26;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getUserIneligible = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible, 26));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.UserIneligible|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setUserIneligible = function(value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearUserIneligible = function() {
  return this.setUserIneligible(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasUserIneligible = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional AlreadyEnrolled already_enrolled = 27;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getAlreadyEnrolled = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled, 27));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.AlreadyEnrolled|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setAlreadyEnrolled = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearAlreadyEnrolled = function() {
  return this.setAlreadyEnrolled(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasAlreadyEnrolled = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional IncorrectBirthDate incorrect_birth_date = 28;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getIncorrectBirthDate = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate, 28));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.IncorrectBirthDate|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setIncorrectBirthDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearIncorrectBirthDate = function() {
  return this.setIncorrectBirthDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasIncorrectBirthDate = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional CountryNotSupported country_not_supported = 29;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getCountryNotSupported = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported, 29));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.CountryNotSupported|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setCountryNotSupported = function(value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearCountryNotSupported = function() {
  return this.setCountryNotSupported(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasCountryNotSupported = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional InvalidZipCode invalid_zip_code = 30;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getInvalidZipCode = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode, 30));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.InvalidZipCode|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setInvalidZipCode = function(value) {
  return jspb.Message.setOneofWrapperField(this, 30, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearInvalidZipCode = function() {
  return this.setInvalidZipCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasInvalidZipCode = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional ConfirmDobAttemptsExhausted confirm_dob_attempts_exhausted = 31;
 * @return {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.getConfirmDobAttemptsExhausted = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted, 31));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.ConfirmDobAttemptsExhausted|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
*/
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.setConfirmDobAttemptsExhausted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 31, proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError} returns this
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.clearConfirmDobAttemptsExhausted = function() {
  return this.setConfirmDobAttemptsExhausted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.enrollment.common.ValidationError.prototype.hasConfirmDobAttemptsExhausted = function() {
  return jspb.Message.getField(this, 31) != null;
};


goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.enrollment.common);
